import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Spacer, PageDS, ToastContainerDS, TabMenu } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import { FetchVehicleSivData } from "./fetchVehicleSivData";
import "../../i18n/i18n";

export const Vehicles = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "fetchVehicleSivData",
  );

  useEffect(() => {
    if (selectedTab) {
      navigate(`/home/vehicles/${selectedTab}`);
    }
  }, [navigate, selectedTab]);

  const tabs = [
    {
      name: "fetchVehicleSivData",
      title: t("vehicles.tab.fetchVehicleSivData"),
    },
  ];

  return (
    <PageDS
      title={t(`vehicles.${params.tab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <FetchVehicleSivData />
    </PageDS>
  );
};
